import { render } from "./recent-registrations-widget.vue?vue&type=template&id=17b7e250"
import script from "./recent-registrations-widget.vue?vue&type=script&lang=ts"
export * from "./recent-registrations-widget.vue?vue&type=script&lang=ts"
script.render = render

export default script